<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility">Invoice Adjustment</h1>
        </div>

        <div class="ppl-container">
            <div class="ppl-content-container">

                <!-- Filter + Notes -->
                <div class="w-100">
                    <ppl-invoice-filter [pageId]="pageId"
                        [filterFields]="fields"
                        (searchEvent)="onSearch($event)">
                    </ppl-invoice-filter>

                    <p class="pl-2">
                        <span class="error-message1">*</span>
                        At least one out of the following fields should be
                        populated:
                        <b>Provider PPL ID</b>, <b>Service Code</b>, <b>Service
                            Date</b>.
                    </p>

                    <div>
                        <p><strong>Note:</strong></p>
                        <ul>
                            <li>For <strong>Adjust Invoice</strong> and
                                <strong>Void Invoice</strong> actions, please
                                select the applicable invoice.</li>
                        </ul>
                    </div>
                </div>

                <!-- Data Table -->
                <div class="table-style">
                    @if (!listReloading){
                    @if (hasSearched) {
                    <ppl-list-table [cols]="cols" [disableSort]="true"
                        [disableSearch]="true" [showCustomSearch]="false"
                        [data]="timesheets" [customDataLoaded]="true"
                        [enableActions]="false" [from]="'invoices'"
                        [gridTitle]="false" [pagination]="true"
                        [loadPage]="true" [actionButtons]="actionButtons"
                        [enablePageActions]="!isReadOnly"
                        [timesheetFor]="'pendedTimesheet'"
                        [listButton]="isReadOnly ? [] : buttons"
                        (actionInvoked)="gridAction($event)"
                        (onPageLoad)="onPageLoad($event)"
                        (rowCellClicked)="onCellClicked($event)"
                        (rowDetailEventTs)="onRowActions($event)"
                        [onViewUser]="onViewUserClicked">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning">
                        <strong>No Records Found.</strong> Please change the
                        filters to find the records.
                    </div>
                    }
                    }

                </div>

            </div>
        </div>
    </div>
</ng-container>

<!-- Adjust / Void Dialog -->
<div class="filter-panel">
    <ng-template #timesheetAdjustVoidDialog let-cancel="cancel">
        <ppl-invoice-adjust-void-entry [timesheetData]="timesheetData"
            [searchParams]="appliedFilters"
            [actionData]="selectedAction"
            (timesheetAdjustedOrVoided)="timesheetAdjustedOrVoided($event)">
        </ppl-invoice-adjust-void-entry>
    </ng-template>
</div>

<!-- Search Filter Warning Dialog -->
<div class="filter-panel">
    <ng-template #searchFilterWarningDialog let-cancel="cancel">
        <p>
            At least one out of the following fields should be populated:
            Provider PPL ID, Service Code, Service Date.
        </p>
    </ng-template>
</div>

<!-- Authorization Details Dialog -->
<div class="filter-panel">
    <ng-template #authDialog let-cancel="cancel">
        <ppl-authorization-details [authorizationId]="selectedAuthorizationId" [pageSource]="'invoice'"
            [isReadOnly]="true"></ppl-authorization-details>
    </ng-template>
</div>

<!-- Paystub PDF Viewer Dialog -->
<div class="filter-panel">
    <ng-template #pdfDialog let-cancel="cancel">
        <div *ngIf="pdfConfig && pdfFile">
            <ppl-editpdf (fieldsUpdated)="onPdfFieldsUpdated($event)"
                [readonly]="true" [pdfConfig]="pdfConfig"
                [signature] [pdfBlob]="pdfBlob" [pdfFile]="pdfFile"
                [signatureId]
                [isSelf]="true"></ppl-editpdf>
        </div>
    </ng-template>
</div>
